import React, { HTMLAttributes } from "react";
import styled from "styled-components";
import Colors from "../theme/Colors";

export interface DismissIconProps extends HTMLAttributes<SVGElement> {
  color?: string;
  size?: number;
}

const DismissIcon = styled(function ({
  size = 24,
  color = Colors.disabled,
  ...props
}: DismissIconProps) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill={color}>
        <path d="M4.222 2.808l16.97 16.97-1.414 1.414-16.97-16.97z" />
        <path d="M19.778 2.808l1.414 1.414-16.97 16.97-1.414-1.414z" />
      </g>
    </svg>
  );
})``;

export const DismissIconCircle = styled(function ({
  size = 24,
  color = Colors.disabled,
  ...props
}: DismissIconProps) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <defs>
        <mask id="cross" maskContentUnits="objectBoundingBox">
          <circle cx=".5" cy=".5" r=".5" fill="white" />
          <g transform="rotate(45) translate(0.20833, -0.5)">
            <rect
              x="0.15"
              y="0.4583"
              width="0.7"
              height="0.0833"
              fill="black"
            />
            <rect
              x="0.4583"
              y="0.15"
              width="0.0833"
              height="0.7"
              fill="black"
            />
          </g>
        </mask>
      </defs>
      <circle fill={color} cx="12" cy="12" r="12" mask="url(#cross)" />
    </svg>
  );
})``;

export default DismissIcon;
